import type { ReactNode } from "react";

type QuotationItemDrawerFieldsProps = {
  productField: ReactNode;
  inlineProductPanel: ReactNode;
  supplierField: ReactNode;
  supplierWarning: ReactNode;
  inlineSupplierPanel: ReactNode;
  priceSection: ReactNode;
  unitSection: ReactNode;
  pricePreview: ReactNode;
  offerField: ReactNode;
};

export function QuotationItemDrawerFields({
  productField,
  inlineProductPanel,
  supplierField,
  supplierWarning,
  inlineSupplierPanel,
  priceSection,
  unitSection,
  pricePreview,
  offerField,
}: QuotationItemDrawerFieldsProps) {
  return (
    <div className="lnk-editor-fields">
      <div className="quotation-editor-field">
        {productField}
        {inlineProductPanel}
      </div>

      <div className="quotation-editor-field">
        {supplierField}
        {supplierWarning}
        {inlineSupplierPanel}
      </div>

      {priceSection}
      {unitSection}
      {pricePreview}
      {offerField}
    </div>
  );
}
